import React from 'react';
import { Container, Row, Col } from "react-bootstrap";


const Terms = () => {
    return (
      <Container className="my-5">
      <Row className="justify-content-center">
        <Col md={8} className="text-center text-color-site">   
          <h1 className="display-4">Termos de Serviço</h1>

          <div className="my-4 text-start">
            <p>
                Última atualização: 19 de abril de 2025 
            </p>
            
            <p>
            Estes Termos de Serviço ("Termos") regem o uso do website [https://zauso-dev.com.br] ("o Site") e os serviços relacionados oferecidos por nós ("nós", "nosso" ou "nossa").
            Ao acessar ou utilizar o Site, você concorda em cumprir estes Termos e em ficar vinculado por eles. Se você não concordar com algum termo ou condição aqui estabelecido, recomendamos que não utilize o Site.
            </p>
            
            <h1 className="display-4">Uso do Site</h1>
            <p>O uso do Site está sujeito aos seguintes termos:</p>
            <p>
                a. Você concorda em usar o Site apenas para fins legítimos e de acordo com todas as leis e regulamentos aplicáveis.<br />
                b. Você concorda em não usar o Site de maneira que possa danificar, desabilitar, sobrecarregar ou prejudicar o Site ou interferir no uso e na operação adequados do Site por terceiros. <br />
                c. Você reconhece que todas as informações e conteúdos disponibilizados no Site são protegidos por direitos autorais e outras leis de propriedade intelectual, e você concorda em respeitar tais direitos.
            </p>
        
            <h1 className="display-4">Alterações dos Termos</h1>
            <p>
                Podemos modificar ou atualizar estes Termos a qualquer momento, e tais alterações entrarão em vigor imediatamente após a publicação dos Termos atualizados no Site. É sua responsabilidade revisar periodicamente os Termos para ficar ciente de quaisquer alterações. 
                O uso contínuo do Site após a publicação das alterações constituirá a sua aceitação das mesmas.
            </p>
          </div>
          </Col>  
       </Row>
    </Container>
    )
}
export default Terms;